import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ClrWizard } from "@clr/angular";
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { NgForm } from '@angular/forms';
import { Service } from './out-of-place-restore.service';

@Component({
  selector: 'out-of-place-restore',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./out-of-place-restore.scss')],
  template: require('./out-of-place-restore.html')
})

export class OutOfPlaceRestore {
  @ViewChild("wizard") wizard: ClrWizard;
  @Input('isVisible') isVisible: boolean;
  @Input('selectedEntity') selectedEntity;
  @Input('selectedRestorePoint') selectedRestorePoint;
  @Output('onClose') selfClose = new EventEmitter();

  private subscribeHandler;

  private vcId: String;
  private name: String;
  private destination;
  private destinationDatacenter: String;
  private computeResource;
  private datastores = [];
  private destinationDatastore;

  private isLoading = false;
  private errorFlag = false;
  private errorMsg: String = '';

  constructor(public outOfPlaceRestoreService: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes) {
    if (changes && changes.selectedEntity && changes.selectedEntity.currentValue && changes.selectedEntity.currentValue.vcenter_instanceId) {
      this.vcId = changes.selectedEntity.currentValue.vcenter_instanceId;
    }
  }

  onDestinationSelection(destination) {
    this.destination = destination;
    if (this.destination && this.destination.datacenter) {
      this.destinationDatacenter = this.destination.datacenter.entity_id;
    }
  }

  onNewNameInputChange(name) {
    this.name = name;
  }

  onStepOneCommit() {
    this.isLoading = true;
    if (this.name) {
      if (this.destination) {
        this.wizard.next();
      } else {
        this.errorMsg = this.translate.instant('vcDpsModule.outOfPlaceRestore.message.invalidLocation');
        this.errorFlag = true;
      }
    } else {
      this.errorMsg = this.translate.instant('vcDpsModule.outOfPlaceRestore.message.emptyName');
      this.errorFlag = true;
    }
    this.isLoading = false;
  }

  onComputeResourceSelection(computeResource) {
    this.computeResource = computeResource;
  }

  onStepTwoCommit() {
    this.isLoading = true;
    if (this.computeResource) {
       this.subscribeHandler = this.outOfPlaceRestoreService.getRestoreTargetDatastores(this.vcId,
              this.computeResource.entityType, this.computeResource.entity_id).subscribe((datastores: any) => {
              this.datastores = datastores;
              if (this.datastores && this.datastores.length > 0) {
                this.wizard.next();
              } else {
                this.errorMsg = this.translate.instant('vcDpsModule.outOfPlaceRestore.message.invalidComputeResource');
                this.errorFlag = true;
              }
              this.isLoading = false;
          },
          error => {
              this.isLoading = false;
              this.errorMsg = this.translate.instant('vcDpsModule.outOfPlaceRestore.message.errorValidating');
              this.errorFlag = true;
          },
          () => {}
      );
    } else {
      this.errorMsg = this.translate.instant('vcDpsModule.outOfPlaceRestore.message.invalidComputeResource');
      this.errorFlag = true;
      this.isLoading = false;
    }
  }

  onDestinationDatastoreSelection(destinationDatastore) {
    this.destinationDatastore = destinationDatastore;
  }

  onStepThreeCommit() {
    this.isLoading = true;
    if (this.destinationDatastore) {
      let restoreAttributes = {
        ignoreWarnings: true,
        name: this.name,
        datacenter: this.destination.datacenter.name,
        datastore: this.destinationDatastore.name,
        datastoreId: this.destinationDatastore.entity_id,
        entityType: this.computeResource.entityType,
        entity_id: (this.computeResource.entityType === 'host') ? this.computeResource.name : this.computeResource.entity_id,
        vmFolder: this.destination.folder,
        vmPath: this.destination.path
      }

      let payload = {
        restorePointId: this.selectedRestorePoint.id,
        restoreAttributes: restoreAttributes
      }

      this.subscribeHandler = this.outOfPlaceRestoreService.runOutOfPlaceRestore(this.vcId,
              payload).subscribe(res => {
              this.isLoading = false;
              this.wizard.close();
          },
          error => {
              this.isLoading = false;
              this.errorMsg = this.translate.instant('vcDpsModule.outOfPlaceRestore.message.errorOutOfPlaceRestore');
              this.errorFlag = true;
          },
          () => {}
      );
    } else {
      this.errorMsg = this.translate.instant('vcDpsModule.outOfPlaceRestore.message.emptyDatastore');
      this.errorFlag = true;
      this.isLoading = false;
    }
  }

  onWizardPageLoad() {
    this.errorFlag = false;
  }

  onAlertClose() {
    this.errorFlag = false;
  }

  onWizardStateChanged(event) {
    if (event === false)
      this.name = null;
      this.destination = null;
      this.computeResource = null;
      this.datastores = null;
      this.errorFlag = false;
      this.closeSelf();
  }

  closeSelf() {
    if ( this.selfClose ) {
      this.selfClose.emit({
        value: 'close'
      });
    }
  }

  ngOnDestroy() {
    if ( this.subscribeHandler ) {
      this.subscribeHandler.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/out-of-place-restore/out-of-place-restore.component.ts